export default "__VITE_ASSET__8u1FpgU0__"